import React, {Component} from 'react';
import './App.css';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import Slider from "react-slick";
import { withTranslation, Trans } from 'react-i18next';

import mainSlideImg from "./img/mainSlider.jpg";

import mainSlideImg1 from "./img/mainSlide1.jpg";
import mainSlideImg2 from "./img/mainSlide2.jpg";
import mainSlideImg3 from "./img/mainSlide3.jpg";
import mainSlideImg4 from "./img/mainSlide4.jpg";
import mainSlideImg5 from "./img/mainSlide5.jpg";
import mainSlideImg6 from "./img/mainSlide6.jpg";
import mainSlideImg7 from "./img/mainSlide7.jpg";


import {Helmet} from "react-helmet";



class MainHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            projects: [],
            services: [],
            expertise: [],
            homepageHero : {}
        }
    };


    componentDidMount() {
        $(window).scrollTop(0);

    }

    render() {
        const {i18n, t} = this.props;
        var settings = {
            dots: false,
            infinite: true,
            arrows:false,
            fade:true,
            autoplay:true,
            speed: 3500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0
        };
        return (
            <div>
                <Helmet>
                    <title>{i18n.exists('home.seo.title') ? t('home.seo.title') : "Agile CE"}</title>
                    <meta name="description" content={i18n.exists('home.seo.description') ? t('home.seo.description') : ""} />
                    <meta property="og:title" content={i18n.exists('home.seo.title') ? t('home.seo.title') : "Agile CE"} />
                    <meta property="og:description" content={i18n.exists('home.seo.description') ? t('home.seo.description') : ""} />
                </Helmet>
                <div className="container content fade-in-website home" id="home">

                    <h1 style={{textAlign: "center"}}>„Žádná inženýrská výzva není příliš velká, žádný projekt příliš malý.“</h1>
                    <div>

                        <Slider {...settings}>
                            <div>
                                <img src={mainSlideImg3}/>
                            </div>
                            <div>
                                <img src={mainSlideImg6}/>
                            </div>
                            <div>
                                <img src={mainSlideImg1}/>
                            </div>
                            <div>
                                <img src={mainSlideImg2}/>
                            </div>

                            <div>
                                <img src={mainSlideImg4}/>
                            </div>
                            <div>
                                <img src={mainSlideImg5}/>
                            </div>

                            <div>
                                <img src={mainSlideImg7}/>
                            </div>
                        </Slider>
                    </div>

                    <span >Jsme statická projekční kancelář se širokým spektrem činnosti v oblasti statiky pozemních staveb,
                        mostních a inženýrských konstrukcí a geotechniky. Nabízíme konzultace projektů již
                        od fáze studie a dodáváme kompletní projektovou dokumentaci až do fáze realizace
                        pro přední české architektonické ateliéry a významné projekční a stavební firmy.
                        Naší předností je rychlost a hledání přímočarých cenově efektivních řešení. </span>

                </div>



            </div>
        );
    }
}

export default withTranslation()(MainHome);
